<template>
  <ButtonTertiary
    class="font-regular"
    :class="button_class"
    @click="$emit('onClick')"
  >
    <slot />
  </ButtonTertiary>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  is_toggled: { type: Boolean },
  color: { type: String, default: '!bg-primary-500 !text-primary-contrast' },
  is_background_transparent: { type: Boolean },
});

defineEmits(['onClick']);

const button_class = computed(() => {
  if (props.is_toggled) {
    return props.color;
  }
  if (props.is_background_transparent) {
    return '!bg-transparent';
  }
  return '';
});
</script>
